module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(52)
    }
  }, [_c('v-card', [_vm._l((_vm.getChildrenListSteps), function(step) {
    return [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c(step.class || 'v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false))], 1)]
  })], 2), _vm._v(" "), (_vm.actions && _vm.actions.length > 0) ? _c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.isAllActions,
      "caption": this.isAllActions ? 'Показать незавершенные' : 'Показать все'
    },
    on: {
      "click": function($event) {
        _vm.isAllActions = !_vm.isAllActions
      }
    }
  }, [_c('v-items-field', {
    attrs: {
      "label": "Журнал",
      "items": _vm.getScheduledActions(),
      "smallIcons": ""
    },
    on: {
      "click": function($event) {
        return _vm.onActionClick($event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.strategy.getSteps().length > 0) ? _c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.currentStep),
      callback: function($$v) {
        _vm.currentStep = $$v
      },
      expression: "currentStep"
    }
  }, [_vm._l((_vm.strategy.getSteps()), function(step) {
    return [_c('v-stepper-step', {
      attrs: {
        "complete": _vm.complete(step),
        "step": step.number,
        "editable": _vm.editable(step)
      }
    }, [_vm._v("\n            " + _vm._s(step.title) + "\n            "), (step.subTitle) ? _c('small', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(typeof step.subTitle === 'function' ? step.subTitle(step) : '')
      }
    })]) : _vm._e()]), _vm._v(" "), _c('v-stepper-content', {
      attrs: {
        "step": step.number
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c(step.class || 'v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false)), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "disabled": !step.nextEnabled()
      },
      on: {
        "click": function($event) {
          return _vm.next(step)
        }
      }
    }, [_vm._v(_vm._s(step.nextLabel()))]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "flat": "",
        "disabled": !step.backEnabled()
      },
      on: {
        "click": function($event) {
          return _vm.back(step)
        }
      }
    }, [_vm._v(_vm._s(step.backLabel()))])], 1)], 1)], 1)]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewable()),
      expression: "previewable()"
    }],
    on: {
      "click": function($event) {
        return _vm.preview(null, 'color')
      }
    }
  }, [_vm._v("Просмотр")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.dialogOpenAssistForm()
      }
    }
  }, [_vm._v("Атрибуты")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc74e62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/AssistPackage.vue
// module id = 1168
// module chunks = 1